export default {
  getButtonList: (state) => {
    return state.buttonList
  }
}
